import { useEffect, useRef } from 'react';
import { useFlags } from '@flagsmith/flagsmith/react';
import { useAuth } from '../contexts/AuthContext';
import { useNotification } from '../contexts/NotificationContext';
import { Toast, ToastVariant } from '../components/shared/notification/Toast';
import { Cart } from '../models/cart.types';

export function useNewProspectWelcomeToast(cart: Cart | undefined) {
  const { isLoggedIn } = useAuth();
  const { showNotification } = useNotification();
  const flags = useFlags(['prospect-welcome-toast']);
  const isEnabled = flags['prospect-welcome-toast'].enabled && flags['prospect-welcome-toast'].value === 'show';
  const isNewProspect = useRef(
    !isLoggedIn
    && !document.cookie.includes('logged_out_cart_id')
    && !sessionStorage.getItem('welcomeToastShown'),
  );

  useEffect(() => {
    if (isEnabled && isNewProspect.current && cart?.cartItems?.length) {
      isNewProspect.current = false;
      sessionStorage.setItem('welcomeToastShown', '1');
      showNotification({
        content: <Toast variant={ToastVariant.WELCOME_PREFILLED_CART} />,
      });
    }
  }, [cart, isEnabled]);
}
